export default "__VITE_ASSET__DBcWK$Um__"